import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { MapPin, ArrowRight } from "lucide-react";

const popularCities = [
  { name: "Amsterdam", slug: "amsterdam", province: "Noord-Holland" },
  { name: "Rotterdam", slug: "rotterdam", province: "Zuid-Holland" },
  { name: "Den Haag", slug: "den-haag", province: "Zuid-Holland" },
  { name: "Utrecht", slug: "utrecht", province: "Utrecht" },
  { name: "Eindhoven", slug: "eindhoven", province: "Noord-Brabant" },
  { name: "Breda", slug: "breda", province: "Noord-Brabant" },
  { name: "Amstelveen", slug: "amstelveen", province: "Noord-Holland" },
  { name: "Rijswijk", slug: "rijswijk", province: "Zuid-Holland" },
  { name: "'s-Hertogenbosch", slug: "den-bosch", province: "Noord-Brabant" },
  { name: "Arnhem", slug: "arnhem", province: "Gelderland" },
  { name: "Groningen", slug: "groningen", province: "Groningen" },
  { name: "Tilburg", slug: "tilburg", province: "Noord-Brabant" },
];

const PopularCitiesSection = () => {
  return (
    <section className="py-16 md:py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <Badge className="mb-4 bg-primary/10 text-primary border-0 px-4 py-1.5">
            <MapPin className="w-4 h-4 mr-1" />
            Verhuizen per stad
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Populaire verhuissteden
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Vind de beste verhuisbedrijven in uw regio en vergelijk gratis verhuisoffertes
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {popularCities.map((city) => (
            <Link
              key={city.slug}
              to={`/verhuizen/${city.slug}`}
              className="group p-4 rounded-xl bg-card border border-border/50 hover:border-primary/30 hover:shadow-lg transition-all text-center"
            >
              <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors mb-1">
                {city.name}
              </h3>
              <p className="text-xs text-muted-foreground">{city.province}</p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link 
            to="/verhuisbedrijven" 
            className="inline-flex items-center gap-2 text-primary hover:text-primary/80 font-medium transition-colors"
          >
            Bekijk alle steden
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PopularCitiesSection;
